import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchInventoryStockMovementItemOptions } from '@/renderer/services/inventoryStockMovementService';
import type { InventoryStockMovementItemOptionFilterParams } from '@/renderer/types/inventory';

export function useInventoryStockMovementItemOptions(
  params: InventoryStockMovementItemOptionFilterParams,
) {
  return useQuery({
    queryKey: queryKeys.inventory.stockMovementItemOptions(params),
    queryFn: async () => {
      const result = await fetchInventoryStockMovementItemOptions(params);
      if (!result.success || !result.data) {
        throw new Error(
          result.error ?? 'Failed to fetch stock movement item options',
        );
      }

      return result.data;
    },
    enabled: !!params.companyId && !!params.outletId,
    placeholderData: keepPreviousData,
  });
}
